<div class="inquiry">
  <div class="laoding" *ngIf="loading">
    <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
  </div>
    <div class="inquiryHeader" *ngIf="!filterVisible">
        <div class="inquiryTitle">{{'inquiry.list' | translate }}</div>

          <button mat-raised-button color="primary" class="addTicket ml21"  (click)="addTicket()">+ {{'inquiry.newTicket' | translate }}</button>
    </div>
    <div class="inquirySearch" *ngIf="!filterVisible">
        <form nz-form  class="ant-advanced-search-form pd20">
            <div nz-row [nzGutter]="24">
              <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-control>
                      <nz-input-group [nzSuffix]="suffixIconSearch">
                      <input type="text" [(ngModel)]="keywords" nz-input placeholder="{{'input.keyword' | translate}}"  [ngModelOptions]="{standalone: true}"
                        class="w355" />
                      </nz-input-group>
                      <ng-template #suffixIconSearch>
                      <span nz-icon nzType="search" (click)="searchInquiryList(true)"></span>
                      </ng-template>
                    </nz-form-control>
                  </nz-form-item>
              </div>
            </div>
            <div nz-row [nzGutter]="24">
              <div nz-col [nzSpan]="24">
                <div class="filter">
                  <button mat-raised-button color="primary" class="mr20 filterBtn"  (click)="refresh()">{{'button.refresh' | translate}}</button>
                  <button mat-raised-button color="primary" class="filterBtn"  (click)="showFilter()">{{'button.filter' | translate}}</button>
                </div>
              </div>
            </div>
        </form>
    </div>
    <div class="inquiryList" *ngIf="!filterVisible">
        <div class="result"> {{'form.total' | translate }} {{total}} {{'form.row' | translate }} <nz-pagination [(nzPageIndex)]="pageIndex" [nzTotal]="total" [nzPageSize]="pageSize" [nzSize]="'small'" (nzPageIndexChange)="searchInquiryList()"></nz-pagination></div>
        <ul nz-list [nzDataSource]="listOfData" nzBordered nzSize="large" *ngIf="listOfData.length > 0">
            <li nz-list-item *ngFor="let item of listOfData" nzNoFlex (click)="showInfo(item)">
              <div>
                 <div>{{'ticket.ticketNo' | translate }}</div>
                 <div>{{item.ticket.ticketNo}}</div>
                 <div>{{item.ticket.submittedDate || item.ticket.createdDate | date:'dd/MM/yyyy HH:mm' }}</div>
              </div>
              <div class="right">
                <div class="statusCss">{{ getStatus(item.ticket.ticketStatusID || 0)}}</div>
                <div class="detail"  nz-tooltip nzTooltipTitle="{{item.ticket.detail}}">{{ item.ticket.detail }}</div>
              </div>
            </li>
          </ul>

          <ul nz-list  nzBordered nzSize="large" *ngIf="listOfData.length == 0">
            <li class="empty_li">
              <div>
                <nz-empty [nzNotFoundContent]="contentTpl"></nz-empty>
                <ng-template #contentTpl>
                  <span>
                    {{'ticket.empty' | translate }}
                  </span>
                </ng-template>
              </div>
            </li>
          </ul>
    </div>
    <div *ngIf="filterVisible">
      <app-mobile-filter (isClose)="close()" (isSave)="save()" #filter></app-mobile-filter>
    </div>

</div>
